export default {
  WHITE: '#FFFFFF',
  GREY: '#f4f4f4',
  BUTTON: { PRIMARY: '#d6011e', SECONDARY: '', DANGER: '', DISABLED: '#f2f2f2', DEFAULT: '#ffffff', BANNER: '#D7001D' },
  FONT: {
    NORMAL: '#3f3f3f',
    DANGER: '#d6011e',
    CHERRY: '#d6011e',
    WARNING: '#f89b32',
    LINK: '#3462b8',
    INVERT: '#FFFFFF',
    ANNOTATION: '#979797',
    GREY: '#979797',
    DARK_GREY: '#777777',
    STEEL: '#84848f',
    BLACK: '#000000',
    BUTTON_PRIMARY: '#ffffff',
    BUTTON_DISABLED: '#8b93a4',
    BUTTON_DEFAULT: '#7c7c7c',
    MENU_DARK: '#111111',
    ANNOTATION_RED: '#D7001D',
  },
  BACKGROUND: {
    BASE: '#FFFFFF',
    MODAL: '#FFF',
    HEADER: 'linear-gradient(135deg, #bb0013, #800)',
    SIDE_MENU: 'linear-gradient(to right, #3b2a3a 0, #2b2e3d 100%)',
    ACCORDION: '#f2f5fa',
    INVERT: '#FFFFFF',
    BLOCK: '#fbfbfb',
    ICON_STEEL: '#F7F7F7',
    POPUP_GRAY: 'rgba(0, 0, 0, 0.8)',
    MOBILE_LABEL: '#F8F6F6',
    BANNER: '#FAF9F8',
  },
  LINE: {
    NORMAL: 'rgba(0,0,0,0.1)',
    POWER_BLUE: 'rgba(197, 220, 232, 1)',
    FOOTER: 'rgba(0,0,0,0.08)',
    SHADOW: 'rgba(51, 47, 41, 0.06)',
    ALERT: 'rgba(0,0,0,0.08)',
    PAGE_TITLE: '#F4F4F4',
    ICON: 'rgba(0,0,0,0.8)',
    ANNOUNCE: '#ff0000',
  },
  BORDER: {
    MENU: '#E2E2E2',
  },
}
